import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function ResidencyQuestion() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const privacyContent = <>
      <p data-id="element-59">
        <strong data-id="element-60">Last Updated: May 2026</strong>
      </p>
      <p data-id="element-61">
        This Privacy Policy describes how we collect, use, and share your
        personal information when you use our lead generation services for
        bathroom remodeling.
      </p>
      <h3 className="text-lg font-semibold text-gray-900 mt-4 mb-2" data-id="element-62">
        1. Information We Collect
      </h3>
      <p data-id="element-63">
        We collect information you provide directly to us, such as your name,
        contact information, and property details when you fill out our
        qualification forms.
      </p>
      <h3 className="text-lg font-semibold text-gray-900 mt-4 mb-2" data-id="element-64">
        2. How We Use Your Information
      </h3>
      <p data-id="element-65">
        We use the information we collect to connect you with qualified bathroom
        remodeling contractors in your area, communicate with you about your
        request, and improve our services.
      </p>
      <h3 className="text-lg font-semibold text-gray-900 mt-4 mb-2" data-id="element-66">
        3. Sharing with Partners
      </h3>
      <p data-id="element-67">
        By submitting your information, you direct us to share your details with
        our network of independent contractors and partner networks who may
        contact you regarding your remodel project.
      </p>
      <h3 className="text-lg font-semibold text-gray-900 mt-4 mb-2" data-id="element-68">
        4. Opt-Out Rights
      </h3>
      <p data-id="element-69">
        You may opt out of future communications at any time by following the
        unsubscribe instructions in our emails or replying "STOP" to our SMS
        messages.
      </p>
    </>;
  const termsContent = <>
      <p data-id="element-70">
        <strong data-id="element-71">Last Updated: May 2026</strong>
      </p>
      <p data-id="element-72">
        Please read these Terms of Service carefully before using our website
        and services.
      </p>
      <h3 className="text-lg font-semibold text-gray-900 mt-4 mb-2" data-id="element-73">
        1. Eligibility
      </h3>
      <p data-id="element-74">
        You must be a resident of the United States and at least 18 years old to
        use our services. By using our site, you represent and warrant that you
        meet these requirements.
      </p>
      <h3 className="text-lg font-semibold text-gray-900 mt-4 mb-2" data-id="element-75">
        2. TCPA Consent
      </h3>
      <p data-id="element-76">
        By clicking "YES" or submitting your information, you provide your
        express written consent to receive automated promotional and
        informational calls and text messages from us and our remodeling
        partners at the phone number provided, even if it is on a state or
        federal Do Not Call list. Consent is not a condition of purchase.
      </p>
      <h3 className="text-lg font-semibold text-gray-900 mt-4 mb-2" data-id="element-77">
        3. Service Disclaimer
      </h3>
      <p data-id="element-78">
        We are a free matching service and not a contractor. We do not guarantee
        the quality of work, pricing, or availability of the contractors in our
        network. You are responsible for evaluating any contractor before hiring
        them.
      </p>
      <h3 className="text-lg font-semibold text-gray-900 mt-4 mb-2" data-id="element-79">
        4. Dispute Resolution
      </h3>
      <p data-id="element-80">
        Any disputes arising out of or relating to these Terms or our services
        will be resolved through binding arbitration, rather than in court.
      </p>
    </>;
  return <section className="w-full py-8 md:py-12 px-4 bg-white flex flex-col items-center" data-id="element-81">
      <div className="max-w-3xl w-full text-center space-y-5" data-id="element-82">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 tracking-tight" style={{
        fontFamily: "'Open Sans', system-ui, sans-serif"
      }} data-id="element-83">
          Are you a US Resident?
        </h1>

        <p className="text-gray-500 text-base md:text-xl max-w-xl mx-auto" data-id="element-84">
          Please answer the question above to check your eligibility for the
          2026 bathroom remodel program.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 pt-2" data-id="element-85">
          <a href="https://skro.dailyhomewellness.com/click" className="w-full sm:w-48 py-4 bg-green-600 hover:bg-green-700 text-white text-2xl font-bold rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200 text-center inline-block" data-id="element-86">
            YES
          </a>
          <a href="https://skro.dailyhomewellness.com/click" className="w-full sm:w-48 py-4 bg-red-600 hover:bg-red-700 text-white text-2xl font-bold rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200 text-center inline-block" data-id="element-87">
            NO
          </a>
        </div>

        <div className="pt-4 flex items-center justify-center gap-6 text-sm" data-id="element-88">
          <button onClick={() => setActiveModal('privacy')} className="text-blue-600 hover:text-blue-800 underline underline-offset-4 transition-colors" data-id="element-89">
            Privacy Policy
          </button>
          <button onClick={() => setActiveModal('terms')} className="text-blue-600 hover:text-blue-800 underline underline-offset-4 transition-colors" data-id="element-90">
            Terms of Service
          </button>
        </div>
      </div>

      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Privacy Policy" content={privacyContent} data-id="element-91" />

      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Terms of Service" content={termsContent} data-id="element-92" />
    </section>;
}